<div class="campaign-hero mobi-ui-margin-t-xxxl">
  @if (entity().images5 && is5Image()) {
    <div class="hero-5-images">
      <mobi-hero-v-images
        [superTitle]="entity().superTitle"
        [subtitle]="entity().subtitle"
        [title]="entity().title"
        [lead]="entity().lead"
        [contentLinks]="contentLinks()"
        [headerImages]="entity().images5"
        [primaryCta]="entity().primaryCta"
        [primaryCtaIcon]="entity().primaryCtaIcon"
        [secondaryCta]="entity().secondaryCta"
        [secondaryCtaIcon]="entity().secondaryCtaIcon"
      />
    </div>
  }
  @if (entity().images3 && is3Image()) {
    <div class="hero-3-images">
      <mobi-hero-v-images
        [superTitle]="entity().superTitle"
        [subtitle]="entity().subtitle"
        [title]="entity().title"
        [lead]="entity().lead"
        [contentLinks]="contentLinks()"
        [headerImages]="entity().images3"
        [primaryCta]="entity().primaryCta"
        [primaryCtaIcon]="entity().primaryCtaIcon"
        [secondaryCta]="entity().secondaryCta"
        [secondaryCtaIcon]="entity().secondaryCtaIcon"
      />
    </div>
  }
  @if (isFullWidthImage()) {
    <div class="hero-full-width-image">
      <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
      <ng-content /><ng-container
        [ngTemplateOutlet]="heroNonImageContent"
        [ngTemplateOutletContext]="{
          fullWidth: false,
        }"
      ></ng-container>
      @if (entity().imageFullWidth) {
        <div class="mobi-ui-grid is-centered mobi-ui-padding-t-lg mobi-ui-margin-t-lg">
          <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
            <div
              class="hero-image-animation-wrapper smMax:full-bleed smMax:!rounded-none"
            >
              <mobi-media
                [entity]="entity().imageFullWidth"
                [mobileEntity]="entity().imageFullWidthMobile"
                rounded="none"
                responsiveStyle="hero_single"
                [lazy]="false"
              />
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (entity().video && isVideo()) {
    <div class="hero-video">
      <div class="mobi-ui-grid is-centered">
        <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
          <div class="mobi-ui-margin-b-xxl mobi-ui-padding-b-sm">
            @defer (hydrate on viewport) {
              <mobi-media [entity]="entity().video" />
            }
          </div>
        </div>
      </div>
      <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
      <ng-content /><ng-container
        [ngTemplateOutlet]="heroNonImageContent"
        [ngTemplateOutletContext]="{}"
      ></ng-container>
    </div>
  }
  @if (entity().imageLeft && isLeftImage()) {
    <div class="hero-left-image">
      <div class="mobi-ui-grid is-centered">
        <div class="mobi-ui-col-1/1 sm:mobi-ui-col-1/2">
          <div class="xsMax:full-bleed">
            <div class="pr-[calc(8*(var(--mobi-ui-scale-unit)))] sm:pr-0">
              <div class="hero-image-animation-wrapper xsMax:!rounded-l-none">
                <mobi-media
                  [animation]="false"
                  [entity]="entity().imageLeft"
                  rounded="right"
                  responsiveStyle="hero_square"
                  [lazy]="false"
                  class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="mobi-ui-col-1/1 sm:mobi-ui-col-1/2">
          <div class="is-right">
            <div class="justify-end mobi-ui-grid">
              <div class="mobi-ui-col-1/1 xl:mobi-ui-col-7/8">
                <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
                <ng-content /><ng-container
                  [ngTemplateOutlet]="heroNonImageContent"
                  [ngTemplateOutletContext]="{
                    fullWidth: 'true',
                  }"
                ></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (entity().imageRight && isRightImage()) {
    <div class="hero-right-image">
      <div class="mobi-ui-grid">
        <div class="mobi-ui-col-1/1 sm:mobi-ui-col-1/2">
          <div class="is-left">
            <div class="mobi-ui-grid">
              <div class="mobi-ui-col-1/1 xl:mobi-ui-col-7/8">
                <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
                <ng-content /><ng-container
                  [ngTemplateOutlet]="heroNonImageContent"
                  [ngTemplateOutletContext]="{
                    fullWidth: 'true',
                  }"
                ></ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="mobi-ui-col-1/1 sm:mobi-ui-col-1/2">
          <div class="xsMax:full-bleed">
            <div class="pl-[calc(8*(var(--mobi-ui-scale-unit)))] sm:pl-0">
              <div class="hero-image-animation-wrapper xsMax:!rounded-r-none">
                <mobi-media
                  [entity]="entity().imageRight"
                  rounded="left"
                  responsiveStyle="hero_square"
                  [lazy]="false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
@if (entity().paragraphs) {
  <div class="page-content">
    @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
      @if (paragraph) {
        <mobi-paragraph-loader
          [bundle]="paragraph.type"
          [data]="{ paragraph: paragraph }"
        />
      }
    }
  </div>
}

<ng-template let-fullWidth="fullWidth" #heroNonImageContent>
  <mobi-hero-text
    [superTitle]="entity().superTitle"
    [subtitle]="entity().subtitle"
    [title]="entity().title"
    [lead]="entity().lead"
    [contentLinks]="contentLinks()"
    [fullWidth]="fullWidth"
    [primaryCta]="entity().primaryCta | extractUrl"
    [primaryCtaTarget]="entity().primaryCta?.options?.attributes?.target"
    [primaryCtaIcon]="entity().primaryCtaIcon"
    [secondaryCta]="entity().secondaryCta | extractUrl"
    [secondaryCtaIcon]="entity().secondaryCtaIcon"
    [secondaryCtaTarget]="entity().secondaryCta?.options?.attributes?.target"
    [primaryCtaTitle]="entity().primaryCta?.title"
    [secondaryCtaTitle]="entity().secondaryCta?.title"
  />
</ng-template>
